
import image_0 from './0.jpg'
import image_1 from './1.jpg'
import image_2 from './2.jpg'
import image_3 from './3.jpg'
import image_4 from './4.jpg'
import image_5 from './5.jpg'
import image_6 from './6.jpg'
import image_7 from './7.jpg'
import image_8 from './8.jpg'
import image_9 from './9.jpg'


export default [
    {url: image_0},
    {url: image_1},
    {url: image_2},
    {url: image_3},
    {url: image_4},
    {url: image_5},
    {url: image_6},
    {url: image_7},
    {url: image_8},
    {url: image_9},
];
